import React, {useEffect, useState} from 'react';
import {getGalleries} from "../api/galeries";

const SlideGaleri = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const [slides, setSlide] = useState([]);

    useEffect(() => {
        getGalleries().then((res) => {
            const response = res.data;
            let galeriTemp = [];
            response.forEach((image) => {
                galeriTemp.push(image)
            })
            setSlide(galeriTemp)
        })
    }, []);

    return (
        <>
            <div className="relative w-full desktop:max-w-6xl phone:max-w-2xl mx-auto overflow-hidden">
                {slides.length === 0 ? (
                    <div className='flex items-center justify-center'>
                        <h1>Galeri kosong..</h1>
                    </div>
                ) : (
                    <div>
                        <div className="grid desktop:grid-cols-3 gap-10 border rounded p-5">
                            {slides.map((slide, index) => (
                                <div key={index} className="min-w-full">
                                    <a href={`/${slide.path}`} target="_blank" rel="noopener noreferrer">
                                        <div className="h-[200px]">
                                            <img src={`/${slide.path}`} alt={`${slide.originalName}`} className="h-full w-full border object-cover"/>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>
        </>
    )
        ;
};

export default SlideGaleri;